<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div
			class="w-100 overflow-hidden"
			:class="(windowWidth<=1000)? 'h-center': ''"
		>
	
			<div v-if="crms.ok != 'null'" class="col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-3">
				<back
					title="گزارش فعالیت روزانه"
					showBtn="false"
				/>
				<div  class="w-100 row d-flex align-items-center align-content-center justify-content-between mb-4" v-if="$localStorage.get('user').username.role==3 && $localStorage.get('user').username.access_level==0">
					<div class="col-4">
					
						<selectInput
							@inputTxtFunc = "(e)=>{val.crmid = e;}"
							:value = "val.crmid"
							label="انتخاب کارشناس CRM"
							:flds="crms.data.content.filter((item, key) => item.access_level == 3)"
						/>
					</div>
					<div class="col-4">
						<selectInput
							@inputTxtFunc = "(e)=>{val.type = e;}"
							:value = "val.type"
							label="انتخاب نوع پیگیری"
							:flds="[
								{'id': '1','name': 'تاریخ انجام شده'},
								{'id': '2','name': 'تاریخ شروع پیگیری'},
								{'id': '3','name': 'پیگیری های روز'},
							]"
						/>
					</div>
					<div class="col-4">
						<datepicker 
						id_tag="date_1"
						class="col-6 pr-0 float-right overflow-hidden" min="false" label="از تاریخ"
						@input="(e) => { val.from = e }" :value="val.from" />

						<datepicker
						id_tag="date_2" class="col-6 pl-0 float-right overflow-hidden" min="false" label="تا تاریخ"
							@input="(e) => { val.to = e }" :value="val.to" />
					</div>
					<div v-if="val.crmid && val.from && val.type" class="col-4 d-flex align-items-center align-content-center justify-content-end">
						<btn text="مشاهده" class="mt-3 w-100" textClass="w-100"
						:disable="(val.from == '') ? '1' : '0'" @clickMe="loader(val.crmid, val.type, val.from, val.to)" />
					</div>
				</div>
				
				<loading
					v-if="flds.ok == null && crms.ok == null"
				/>
				<part1
					:flds="flds.data"
					v-else-if="flds.ok == true"
					@setPage = "setPage"
				/>
				<empty
					text="موردی یافت نشد"
					v-else-if="flds.ok== false"
				/>
			</div>
			<div class="col-lg-3 col-md-3 float-left"  v-if="windowWidth>1000">
				<part2 select="14" />
			</div>
		</div>
		<footerPage />
	</div>
</template>

	<script>
		import headMenu from  "../../menu/headMenu.vue";
		import part1 from  "./part1.vue";
		import back from  "../../UI/back/back.vue";
		import part2 from  "../../USER/reserved_user_list/part2.vue";
		import footerPage from  "../../USER/public/home/home_part9.vue";
		import loading from  "../../UI/loading/loading.vue";
		import empty from  "../../UI/empty/empty.vue";
		import selectInput from "../../UI/input/selectInput.vue";
		import btn from "../../UI/button/btn.vue";
		import datepicker from "../../UI/input/datepicker.vue";
		import { error } from  "../../assets/library/messege.js";
		export default {
			name: 'self',
			data(){
				return {
					error: error,
					imgurl: window.imgurl,
					baseurl: window.baseurl,
					flds: {ok: null, data: []},
					degrees: [],
					category: [],
					location: [],
					val:{
						crmid: '',
						from: '',
						to: '',
						type: '',
					},
					crms: {ok: null, data: []},

				}
			},
			components: {
				part1,
				part2,
				footerPage,
				headMenu,
				back,
				empty,
				loading,
				selectInput,
				datepicker,
				btn,
			},
			props: [],
			computed :{
				error
			},
			mounted(){

				
				this.$swal.close();
				if(this.$localStorage.get('user')==null){
					this.$localStorage.set('urlPath', window.location.pathname);
					this.$router.push('/login');
				}else{
					this.loader();
					this.crmslist();
				}
			},
			methods:{
				setPage(p){
					this.loader(p);
				},
				rtrNewClass(){
					this.$router.push('/admin/create');
				},
				// *********************************************************************
				crmslist( THIS = this){
					if(this.$localStorage.get("user").username.role == 3) {
						window.$.post(this.baseurl+"admin/list", {
							role: this.$localStorage.get("user").username.role, 
							token: this.$localStorage.get("user") 
						}, function(D){
							
						
							if(D.data) {
								THIS.crms = {ok: true, data: D.data};
								
							}
						
						}, "json");
					}
				},
				// *********************************************************************
				loader(crmid , type, from, to, THIS = this){
					var to_test = from ? (to.split("/")[0] + '/'+to.split("/")[1] + '/' + parseInt(to.split("/")[2])) : null;
					var from_test = from ? (from.split("/")[0] + '/'+from.split("/")[1] + '/' + parseInt(from.split("/")[2])) : null;
		

					
					const firstDate = new Date(to_test)
					const secondDate = new Date(from_test)
					if(firstDate < secondDate) {
						THIS.error(THIS, 'تاریخ شروع از پایان بزرگتر است!!!');
					}
					document.body.scrollTop = 0;
					THIS.flds = {ok: null, data: []};
					window.$.post(this.baseurl+"crm/report", {
						crmid: crmid ? crmid : null, 
						type: type ? type : null, 
						from: from ? from : null, 
						to: to ? to : null, 
						role: this.$localStorage.get("user").username.role, 
						token: this.$localStorage.get("user") 
					}, function(D){
						
						THIS.flds = {ok: false, data: []};
						if(D.data) {
							THIS.flds = {ok: true, data: D.data};
						}
					
					}, "json");
				},
				changestatus(adminid , status,THIS = this){
					console.log('adminid', adminid);
					console.log('status', status);
					document.body.scrollTop = 0;
				
					window.$.post(this.baseurl+"crm/changestatus", {
						adminid: adminid ? adminid : null, 
						status: status ? status : null, 
						role: this.$localStorage.get("user").username.role, 
						token: this.$localStorage.get("user") 
					}, function(D){
						
					
						if(D.data) {
							window.location.reload();
						}
					
					}, "json");
				}
				// *********************************************************************
			}
		}
	</script>
<style>

</style>
